import { render, staticRenderFns } from "./_base-button.vue?vue&type=template&id=0c401732&scoped=true&lang=pug&"
import script from "./_base-button.vue?vue&type=script&lang=js&"
export * from "./_base-button.vue?vue&type=script&lang=js&"
import style0 from "./_base-button.vue?vue&type=style&index=0&id=0c401732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c401732",
  null
  
)

export default component.exports